import { render, staticRenderFns } from "./cardProyectGalleryAdmin.vue?vue&type=template&id=388d95aa&scoped=true"
import script from "./cardProyectGalleryAdmin.vue?vue&type=script&lang=js"
export * from "./cardProyectGalleryAdmin.vue?vue&type=script&lang=js"
import style0 from "./cardProyectGalleryAdmin.vue?vue&type=style&index=0&id=388d95aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388d95aa",
  null
  
)

export default component.exports